import { combineReducers } from "@reduxjs/toolkit";
import aggregateBookingReducer from "./AggregateBookingReducer";
import fiveMBookingReducer from "./FiveMBookingReducer";
import tractorBookingReducer from "./TractorBookingsReducer";
import CommonReducer from "./CommonReducers";
import ContainerArrivalReportReducer from "./ContainerArrivalReportReducer";
import ContainerDischargeReportReducer from "./ContainerDischargeReportReducer";
import AddContainerReducers from "./AddContainerReducers";
import AddVGMReducers from "./AddVGMReducers";
import DailyPlanEmailReducer from "./DailyPlanEmailReducer";
import InvoicePackingDocReducers from "./InvoicePackingDocReducers";
import UserAccessDataReducer from "./UserAccessDataReducer";
import TransporterReducers from "./TransporterReducers";
import ContainerMasterEmailReducer from "./ContainerMasterEmailReducer";
import InvoicePackingEmailReducer from "./InvoicePackingEmailReducer";
import VGMEmailReducer from "./VGMEmailReducer";
import TractorETAReducer from "./TractorETAReducer";
import AggregateETAReducer from "./AggregateETAReducer";
import ContainerswapdataReducer from "./ContainerswapdataReducer";
import ContainerswaprowdataReducer from "./ContainerswaprowdataReducer";
import EmailRecepientsReducer from "./EmailRecepientsReducer";
import dashboardReducer from "./dashboardReducer";

export default combineReducers({
  daily_tractor_bookings: tractorBookingReducer,
  daily_aggregate_bookings: aggregateBookingReducer,
  daily_five_m_bookings: fiveMBookingReducer,
  daily_common_reducer_data: CommonReducer,
  transporter_data: TransporterReducers,
  daily_container_arrival_report: ContainerArrivalReportReducer,
  daily_container_discharge_report: ContainerDischargeReportReducer,
  daily_container_swap_row_data: ContainerswaprowdataReducer,
  daily_container_swap_data: ContainerswapdataReducer,
  add_Container_Data: AddContainerReducers,
  add_VGM_Data: AddVGMReducers,
  daily_plan_email_data: DailyPlanEmailReducer,
  invoice_packing_doc: InvoicePackingDocReducers,
  userAccessData: UserAccessDataReducer,
  containerMaster_email: ContainerMasterEmailReducer,
  invoicePacking_email: InvoicePackingEmailReducer,
  VGM_email: VGMEmailReducer,
  tractor_ETA: TractorETAReducer,
  aggregate_ETA: AggregateETAReducer,
  email_recepients : EmailRecepientsReducer,
  dashboardReducer: dashboardReducer,
});
